import ApplicationAdapter from "./application";

export default class DatabaseAdapter extends ApplicationAdapter {
  urlForCreateRecord(): string {
    return `${this.apiBaseUri}/database/create`;
  }

  urlForFindRecord(id: string): string {
    return `${this.apiBaseUri}/database/details?id=${id}`;
  }

  urlForUpdateRecord(id: string): string {
    return `${this.apiBaseUri}/database/updateallowlist?id=${id}`;
  }

  urlForDeleteRecord(id: string): string {
    return `${this.apiBaseUri}/database/delete?id=${id}`;
  }
}
